import ManageTeacherContract from '../../../views/Personnel/Letter/ManageTeacherContract.letter.view';

export default ManageTeacherContract;
